import React from 'react';
import GroupReviewsStateForPeriod from '@app/model/review/state/GroupReviewsStateForPeriod';


const ReviewsGroupSentimentDistributionGraph: React.FunctionComponent<{
	groupReviewsState: GroupReviewsStateForPeriod
}> = ({ groupReviewsState }) => {

	const sentimentDistribution = groupReviewsState.sentimentDistribution();
	const positivePercentage = sentimentDistribution[0] * 100;
	const negativePercentage = sentimentDistribution[1] * 100;
	const states = groupReviewsState.mainHotelStates();
	const positiveSentiments = states.reduce((sum, state) => sum + state.statistics.positiveSentimentCount, 0);
	const negativeSentiments = states.reduce((sum, state) => sum + state.statistics.negativeSentimentCount, 0);

	return <div className="col-span-4">
		<div className="px-3 mb-1">
			<h2 className="text-base font-semibold text-gray-900">Sentiment Distribution</h2>
		</div>
		<div className="overflow-hidden rounded-lg border border-gray-200 bg-white px-5 py-5 shadow-sm">
			<div className="mb-4 flex items-center justify-between gap-4">
				<div className="flex items-center gap-2 text-sm font-medium text-gray-600">
					<span className="h-3 w-3 rounded-full bg-green-500" />
					<span>{positiveSentiments.toLocaleString()} positive</span>
				</div>
				<div className="flex items-center gap-2 text-sm font-medium text-gray-600">
					<span className="h-3 w-3 rounded-full bg-red-500" />
					<span>{negativeSentiments.toLocaleString()} negative</span>
				</div>
			</div>
			<div className="flex h-8 overflow-hidden rounded-full bg-gray-100">
				<div
					className="flex min-w-10 items-center justify-end bg-green-500 px-3 text-sm font-bold text-white"
					style={{ width: `${positivePercentage}%` }}>
					{positivePercentage.toFixed(0)}%
				</div>
				<div
					className="flex min-w-10 items-center justify-start bg-red-500 px-3 text-sm font-bold text-white"
					style={{ width: `${negativePercentage}%` }}>
					{negativePercentage.toFixed(0)}%
				</div>
			</div>
		</div>
	</div>;
};

export default ReviewsGroupSentimentDistributionGraph;
